import styled from "styled-components"
import { Link } from "gatsby"
import {
  CategoriesBarWrapperStyles,
  CategoriesStyles,
  CategoryLinkStyles,
} from "./categories-bar-styles"
import { BreakPoints, media } from "../../helpers/rwd"

export const CategoriesBarWrapper = styled.div`
  ${CategoriesBarWrapperStyles}
`

export const Categories = styled.div`
  display: flex;
  height: 60px;

  ${media.max(BreakPoints.phone)} {
    display: none;
  }
  ${CategoriesStyles}
`

export const CategoryLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 0 20px;
  ${CategoryLinkStyles}
`
